export const addresses = {
  token: "0x2ce1F0e20C1f69E9d9AEA83b25F0cEB69e2AA2b5",
};
